import React from "react";
import "./App.css";
import AppAdmin from './AppAdmin';

function App() {
  return (
    // <Router>
    <div>
      <AppAdmin/>
    </div>
  );
}

export default App;
